export const speak = [
  {
    keyword: 'ceo',
    description:
      "Contact your state's Chief Election Official (Sec. of State, Lt. Gov. or Election Director)",
  },
  {
    keyword: 'congress',
    description: 'Contact your U.S. Senators & U.S. House representative',
    suggested: true,
  },
  {
    keyword: 'dnc',
    description: 'Contact the Democratic National Committee',
  },
  {
    keyword: 'federal',
    description: 'Contact the President and the U.S. Congress',
  },
  {
    keyword: 'house',
    description: 'Contact your representative in the U.S. House',
  },
  {
    keyword: 'gov',
    description: 'Contact your Governor',
  },
  {
    keyword: 'legislature',
    description: 'Contact all your state legislators',
  },
  {
    keyword: 'leo',
    description: 'Contact your local/county election official',
  },
  {
    keyword: 'lower',
    description: 'Contact your state representative(s) or assemblymember(s)',
  },
  {
    keyword: 'mayor',
    description: 'Contact your city or county mayor',
  },
  {
    keyword: 'offices',
    description: 'Get the capitol or local offices for your federal officials',
  },
  {
    keyword: 'officials',
    description: 'List your officials and their phone numbers',
  },
  {
    keyword: 'president',
    description: 'Contact the President',
  },
  {
    keyword: 'senate',
    description: 'Contact one or both of your U.S. Senators',
  },
  {
    keyword: 'sign',
    description:
      'Use with a petition code, e.g., <a href="https://resist.bot/petitions/PUCZGE">SIGN PUCZGE</a> to send that petition to your officials',
  },
  {
    keyword: 'state',
    description: 'Contact your Governor and/or state legislators',
  },
  {
    keyword: 'upper',
    description: 'Contact your state senator(s)',
  },
];

export const vote = [
  {
    keyword: 'check',
    description: 'Check your voter registration & be alerted if it changes',
  },
  {
    keyword: 'early',
    description: 'Find out when and where you can vote early',
  },
  {
    keyword: 'eighteen',
    description: "Get a reminder to register when you're eligible to vote",
  },
  {
    keyword: 'id',
    description: 'Get voter ID requirements & an ID if you need one',
  },
  {
    keyword: 'local',
    description: 'Find and contact your local election office',
  },
  {
    keyword: 'mail',
    description: 'Get vote by mail instructions',
  },
  {
    keyword: 'polls',
    description: 'Find ballot dropboxes and polling places',
  },
  {
    keyword: 'register',
    description: 'Register or pre-register to vote',
  },
  {
    keyword: 'protect',
    description:
      'Report an election problem to the nonpartisan Election Protection coalition',
  },
  {
    keyword: 'track',
    description: 'Track your early or mail-in ballot',
  },
];

export const volunteer = [
  {
    keyword: 'claim',
    description:
      'Claim your <a href="/news/2021/05/06/build-your-following">own keyword</a> and amass followers',
  },
  {
    keyword: 'donate',
    description:
      'Donate to keep Resistbot running and <a href="/news/2021/08/19/every-donation-now-earns-you-coins">earn coins</a> to spend in-bot',
  },
  {
    keyword: 'drive',
    description:
      'Create your own <a href="/news/2020/10/19/vote-registration-and-pledge-drives">voter turnout drive</a> for a race you care about',
  },
  {
    keyword: 'editor',
    description:
      'Submit your last letter as a letter to the editor to your local paper',
  },
  {
    keyword: 'follow',
    description:
      'Use with a username (e.g., FOLLOW ROSIE) to get text updates from a Resistbot member',
  },
  {
    keyword: 'go',
    description:
      'Use with a username (e.g., GO ROSIE) to see and join member campaigns',
  },
  {
    keyword: 'image',
    description: 'Download an image of your last letter',
  },
  {
    keyword: 'import',
    description:
      'Turn your <a href="/news/2020/09/17/launch-your-action-network-petitions-on-resistbot">Action Network petition</a> into a Resistbot campaign',
  },
  {
    keyword: 'invite',
    description: 'Invite a friend to try Resistbot',
    suggested: true,
  },
  {
    keyword: 'moms',
    description:
      'Find local <a href="https://momsdemandaction.org">Moms Demand Action</a> events',
  },
  {
    keyword: 'office',
    description:
      'Locate the D.C. or district offices of your Congressional officials',
  },
  {
    keyword: 'petition',
    description:
      'Make your last letter a signable <a href="/news/2020/01/14/introducing-petitions">petition</a>',
  },
  {
    keyword: 'promote',
    description:
      'Spend coins to <a href="/news/2021/05/18/introducing-rewarded-alerts">promote your petition</a> or vote drive to other Resistbot members',
  },
  {
    keyword: 'run',
    description:
      'Find local elected offices to run for with <a href="https://www.runforsomething.net">Run for Something</a>',
  },
  {
    keyword: 'share',
    description:
      'Make your last letter <a href="https://twitter.com/openletterbot">an open letter</a>',
  },
  {
    keyword: 'signers',
    description:
      'Use with a petition code, e.g., PABCDE, to see how many people have signed a petition and invite more',
  },
  {
    keyword: 'town hall',
    description: 'Find in-person and virtual town halls for your officials',
  },
  {
    keyword: 'turnout',
    description:
      'Invite a friend to check and protect their voter registration',
  },
  {
    keyword: 'volunteer',
    description: 'Find phone banks, canvassing, and other volunteer events',
  },
  {
    keyword: 'worker',
    description: 'Find out how you can work the polls during elections',
  },
];

export const educate = [
  {
    keyword: 'bills',
    description: 'See upcoming bills in the U.S. House',
  },
  {
    keyword: 'donors',
    description:
      "See the top donors to your Congressional officials' campaigns",
  },
  {
    keyword: 'guns',
    description:
      'See how much gun rights and gun safety groups have spent on your representatives',
  },
  {
    keyword: 'nearby',
    description:
      'See <a href="https://twitter.com/openletterbot">open letters</a> from your district',
  },
  {
    keyword: 'NRA',
    description:
      'See how much the gun manufacturers lobby has spent for/against your representatives',
  },
  {
    keyword: 'page',
    description: 'Get up to three newspaper front pages delivered daily',
  },
  {
    keyword: 'police',
    description: 'See police violence data for your city and state',
  },
  {
    keyword: 'recount',
    description:
      'Get a video at the end of each day from <a href="https://therecount.com">The Recount</a>',
  },
  {
    keyword: 'trending',
    description:
      'See what <a href="/petitions">petitions</a> are trending right now',
  },
];

export const account = [
  {
    keyword: 'account',
    description: 'View and change your name, address, and email',
    suggested: true,
  },
  {
    keyword: 'alerts',
    description:
      'Manage what alerts the bot can send you, like <a href="/news/2021/05/18/introducing-rewarded-alerts">promoted alerts</a>, upcoming town halls, and more',
  },
  {
    keyword: 'close',
    description: 'Use with a petition code, e.g., PABCDE, to close a petition',
  },
  {
    keyword: 'coins',
    description: 'See how many Resistbot coins you have',
  },
  {
    keyword: 'commands',
    description: 'Get a list of these commands',
  },
  {
    keyword: 'emails',
    description: 'Manage what kinds of emails the bot can send you',
  },
  {
    keyword: 'feedback',
    description: 'Leave product feedback for the volunteers',
  },
  {
    keyword: 'following',
    description: "See who you're following",
  },
  {
    keyword: 'oops',
    description: 'Rejoin after unsubscribing',
  },
  {
    keyword: 'pair',
    description: 'Use from iMessage or Telegram to pair your SMS account',
  },
  {
    keyword: 'petitions',
    description: "See all petitions you've created",
  },
  {
    keyword: 'preferences',
    description: 'Change bot behaviors',
  },
  {
    keyword: 'stats',
    description: 'See your usage stats and followers',
  },
  {
    keyword: 'stop',
    description: 'Cancel the service completely',
  },
  {
    keyword: 'subscribe',
    description:
      'Start a new monthly donation or change/cancel your existing one',
  },
  {
    keyword: 'support',
    description:
      'If you can’t find an answer on my <a href="/about">help page</a> you can get help with your account here',
    suggested: true,
  },
  {
    keyword: 'upgrade',
    description: 'Upgrade your SMS account to iMessage or Telegram',
  },
];

export const community = [
  {
    keyword: 'blood',
    description: 'Find a local non-profit community blood center',
  },
  {
    keyword: 'coverage',
    description: 'Learn how to get ACA coverage',
  },
  {
    keyword: 'covid',
    description:
      'See current mandates and what’s open and closed in your state',
  },
  {
    keyword: 'covid act',
    description:
      'Get state and county pandemic data from <a href="https://covidactnow.org">COVID Act Now</a>',
  },
  {
    keyword: 'covid test',
    description: 'Find COVID testing sites near you',
  },
  {
    keyword: 'csa',
    description: 'Find Community-Supported Agriculture near you',
  },
  {
    keyword: 'food',
    description: 'Find your nearest food banks',
  },
  {
    keyword: 'hospitals',
    description: 'Data on your local hospital capacities and COVID patients',
  },
  {
    keyword: 'mutual aid',
    description: 'Find your nearest mutual aid networks',
  },
  {
    keyword: 'snap',
    description: 'Learn how to get SNAP benefits in your state',
  },
  {
    keyword: 'vaccine',
    description: 'Find your nearest vaccination location',
  },
];

export const allCommands = [
  ...account,
  ...community,
  ...educate,
  ...speak,
  ...volunteer,
  ...vote,
];

export const allSections = {
  speak,
  vote,
  volunteer,
  educate,
  community,
  account,
};

export const allCommandsByName = new Map();

for (const [section, commands] of Object.entries(allSections)) {
  for (const command of commands) {
    allCommandsByName.set(command.keyword, { command, section });
  }
}
